/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Domain_SalesInputs */

const en_search_domain_sales = /** @type {(inputs: Search_Domain_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the sales orders`)
};

/**
* | output |
* | --- |
* | "the sales orders" |
*
* @param {Search_Domain_SalesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_domain_sales = /** @type {((inputs?: Search_Domain_SalesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Domain_SalesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_domain_sales(inputs)
});